// JSDOM does not implement allSettled.
import * as allsettled from 'promise.allsettled';
allsettled.default ? allsettled.default.shim() : allsettled.shim();
